'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AccordionHeader = require('./AccordionHeader');

var _AccordionHeader2 = _interopRequireDefault(_AccordionHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccordionItem = function (_React$Component) {
  _inherits(AccordionItem, _React$Component);

  function AccordionItem(props) {
    _classCallCheck(this, AccordionItem);

    var _this = _possibleConstructorReturn(this, (AccordionItem.__proto__ || Object.getPrototypeOf(AccordionItem)).call(this, props));

    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  _createClass(AccordionItem, [{
    key: 'handleMouseDown',
    value: function handleMouseDown(e) {
      e.preventDefault();
      this.props.onItemOpen(this.props.idx);
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        this.handleMouseDown(e);
      }
    }
  }, {
    key: 'cloneChildrenWithProps',
    value: function cloneChildrenWithProps(child) {
      if (child) {
        return _react2.default.cloneElement(child, { open: this.props.open, idx: this.props.idx });
      }
      return null;
    }
  }, {
    key: 'renderAccordionHeader',
    value: function renderAccordionHeader(child) {
      if (child) {
        return _react2.default.createElement(
          'div',
          {
            onMouseDown: this.handleMouseDown,
            onKeyDown: this.handleKeyDown,
            tabIndex: '0',
            role: 'button'
          },
          this.cloneChildrenWithProps(child)
        );
      }
      return null;
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren(children) {
      var _this2 = this;

      if (children) {
        return _react2.default.Children.map(children, function (child) {
          return child.type === _AccordionHeader2.default || child.type && child.type.name && child.type.name.includes('AccordionHeader') ? _this2.renderAccordionHeader(child) : _this2.cloneChildrenWithProps(child);
        });
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var itemClasses = (0, _classnames2.default)('accordion__item', { 'accordion__item--active': this.props.open });
      return _react2.default.createElement(
        'div',
        { className: itemClasses },
        this.renderChildren(this.props.children)
      );
    }
  }]);

  return AccordionItem;
}(_react2.default.Component);

exports.default = AccordionItem;


AccordionItem.propTypes = {
  onItemOpen: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  idx: _propTypes2.default.number
};

AccordionItem.defaultProps = {
  onItemOpen: function onItemOpen() {},
  open: true,
  children: _react2.default.createElement(
    'h3',
    null,
    'default children'
  ),
  idx: 0
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/accordion/jsx/AccordionItem.js
// module id = 673
// module chunks = 4